export default [
  {
    path: '/admin/apply/didiAlarm/group/list',
    name: 'didiAlarmGroupList',
    component: () => import('@/views/apply/didiAlarm/group/list/index'),
    meta: {
      title: '群组管理',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/didiAlarm/group/config',
    name: 'didiAlarmGroupConfig',
    component: () => import('@/views/apply/didiAlarm/group/config'),
    meta: {
      title: '基本设置',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/didiAlarm/alarm/list',
    name: 'didiAlarmList',
    component: () => import('@/views/apply/didiAlarm/alarm/list/index'),
    meta: {
      title: '呼叫记录列表',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/didiAlarm/alarm/detail',
    name: 'didiAlarmDetail',
    component: () => import('@/views/apply/didiAlarm/alarm/detail/index'),
    meta: {
      title: '呼叫记录详情',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/didiAlarm/receiver/list',
    name: 'didiAlarmReceiverList',
    component: () => import('@/views/apply/didiAlarm/receiver/list/index'),
    meta: {
      title: '接收端管理',
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/didiAlarm.js